module.exports = __webpack_public_path__ + "about-left.jpg?30021a8fd258f6a575022a0faf41d7ce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-left.jpg
// module id = 78
// module chunks = 0